export default __webpack_public_path__ + "static/media/android-mfa-code.b54511a0.svg";